<template>
  <header class="user-header">
    <div class="user-header-container">
      <div class="user-header-content">
        <!-- Header: Left side -->
        <div class="user-header-left">
          <!-- Hamburger button -->
          <button 
            class="icon-btn hamburger-btn" 
            @click.stop="$emit('toggle-sidebar')" 
            aria-controls="sidebar" 
            :aria-expanded="sidebarOpen"
          >
            <span class="sr-only">Open sidebar</span>
            <svg class="icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="5" width="16" height="2" />
              <rect x="4" y="11" width="16" height="2" />
              <rect x="4" y="17" width="16" height="2" />
            </svg>
          </button>
        </div>

        <!-- Header: Right side -->
        <div class="user-header-right">
          <!-- Guided tour (replay) -->
          <button
            type="button"
            class="icon-btn"
            title="Show PrediX guide"
            aria-label="Show PrediX guide"
            @click="startGuideTour"
          >
            <span class="sr-only">Show PrediX guide</span>
            <svg class="icon" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
              <path
                fill="currentColor"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.25 2C.56 2 0 2.56 0 3.25v8.5C0 12.44.56 13 1.25 13H5c.896 0 1.475.205 1.809.448.317.23.441.51.441.802a.75.75 0 001.5 0c0-.292.124-.572.441-.802.334-.243.913-.448 1.809-.448h3.75c.69 0 1.25-.56 1.25-1.25v-8.5C16 2.56 15.44 2 14.75 2H11c-1.154 0-2.106.354-2.772 1-.081.08-.157.161-.228.246A3.131 3.131 0 007.772 3C7.106 2.354 6.154 2 5 2H1.25zm7.5 9.967c.61-.309 1.372-.467 2.25-.467h3.5v-8H11c-.846 0-1.394.253-1.728.577-.335.325-.522.787-.522 1.34v6.55zm-1.5 0v-6.55c0-.553-.187-1.015-.522-1.34C6.394 3.753 5.846 3.5 5 3.5H1.5v8H5c.878 0 1.64.158 2.25.467z"
              />
            </svg>
          </button>

          <!-- Theme Toggle -->
          <button class="icon-btn" @click="toggleTheme">
            <span class="sr-only">Toggle theme</span>
            <svg v-if="!isDark" class="icon" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 0a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1Z" />
              <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
              <path d="M13.657 3.757a1 1 0 0 0-1.414-1.414l-.354.354a1 1 0 0 0 1.414 1.414l.354-.354ZM13.5 8a1 1 0 0 1 1-1h.5a1 1 0 1 1 0 2h-.5a1 1 0 0 1-1-1ZM13.303 11.889a1 1 0 0 0-1.414 1.414l.354.354a1 1 0 0 0 1.414-1.414l-.354-.354ZM8 13.5a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0v-.5a1 1 0 0 1 1-1ZM4.111 13.303a1 1 0 1 0-1.414-1.414l-.354.354a1 1 0 1 0 1.414 1.414l.354-.354ZM0 8a1 1 0 0 1 1-1h.5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1ZM3.757 2.343a1 1 0 1 0-1.414 1.414l.354.354A1 1 0 1 0 4.11 2.697l-.354-.354Z" />
            </svg>
            <svg v-else class="icon" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.875 4.375a.625.625 0 1 0 1.25 0c.001-.69.56-1.249 1.25-1.25a.625.625 0 1 0 0-1.25 1.252 1.252 0 0 1-1.25-1.25.625.625 0 1 0-1.25 0 1.252 1.252 0 0 1-1.25 1.25.625.625 0 1 0 0 1.25c.69.001 1.249.56 1.25 1.25Z" />
              <path d="M7.019 1.985a1.55 1.55 0 0 0-.483-1.36 1.44 1.44 0 0 0-1.53-.277C2.056 1.553 0 4.5 0 7.9 0 12.352 3.648 16 8.1 16c3.407 0 6.246-2.058 7.51-4.963a1.446 1.446 0 0 0-.25-1.55 1.554 1.554 0 0 0-1.372-.502c-4.01.552-7.539-2.987-6.97-7ZM2 7.9C2 5.64 3.193 3.664 4.961 2.6 4.82 7.245 8.72 11.158 13.36 11.04 12.265 12.822 10.341 14 8.1 14 4.752 14 2 11.248 2 7.9Z" />
            </svg>
          </button>

          <!-- Divider -->
          <hr class="divider" />

          <!-- User Menu -->
          <DropdownProfile align="right" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import DropdownProfile from './DropdownProfile.vue'

export default {
  name: 'UserHeader',
  components: {
    // SearchModal,
    // DropdownNotifications,
    // DropdownHelp,
    DropdownProfile
  },
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchModalOpen: false
    }
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.isDark
    }
  },
  methods: {
    toggleTheme() {
      this.$vuetify.theme.isDark = !this.$vuetify.theme.isDark
      this.$store.commit('darkModeState', this.$vuetify.theme.isDark)
    },
    startGuideTour() {
      if (this.$store.state.IsStaff) return
      this.$emit('start-guide-tour')
    },
    handleHelpClick(type) {
      // Handle help menu clicks
      console.log('Help clicked:', type)
      // You can add navigation or actions here
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles-user-dashboard.scss';

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

// Ensure icon buttons have proper styling
.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  
  &:focus {
    outline: none;
  }
  
  .icon {
    fill: currentColor;
  }
}

</style>
